import { RemoteImage } from 'ui/remote-blob';
import * as React from 'react';
import { filesize } from 'filesize';
import { MdStar } from 'react-icons/md';
import { ObjectFitImage } from 'ui/object-fit-image/object-fit-image';
import { ComplexValue, ComponentProps} from 'ui';
import { UploadedFile } from 'app/area/case/features/file-upload';
import styles from 'ui/file-uploader/file-uploader.scss';
export interface FileUploaderListProps extends ComponentProps {
  id?: number;
  blobId?: number;
  title: string;
  name?: string;
  extension?: string;
  type: string;
  attachedBy: ComplexValue<number>;
  attachedAt: Date;
  size?: number;
  thumbnailSize?: number;
  mainImage?: boolean;
  print?: boolean;  
  loadBlob: (blobId: number, thumbnail: boolean) => Promise<Blob>;
  uploadedFiles: UploadedFile[];
  textNotAvailable?: string;
}

export const FileUploaderList = (props: FileUploaderListProps) => {

  const renderTitle = (file: UploadedFile) => {
    return <h5>{file.title}</h5>;    
  };

  const renderMetadata = (file: UploadedFile) => {
    if (!file?.attachedAt) {
      return null;
    }

    const attachedAt = file.attachedAt
      ? props.formatDate?.(file.attachedAt) +
        ', ' +
        props.formatTime?.(file.attachedAt)
      : props.textNotAvailable;
    const attachedBy = file?.attachedBy
      ? file?.attachedBy?.description
      : '';
    const size = filesize(file.size || 0).toString();

    return (
      <ul className={styles.metadata}>
        {attachedBy && <li>{attachedBy}</li>}
        {attachedAt && <li>{attachedAt}</li>}
        {size && <li>{size}</li>}
      </ul>
    );
  };

  const getBlobFetcher = (blobId: number) => () => {    
    return props.loadBlob(blobId, true) as Promise<Blob>;      
  };
  
  const thumbnail = (file: UploadedFile) => {
    if(!file?.thumbnailSize) {
      return null;
    }

    return <RemoteImage loadBlob={getBlobFetcher(file.blobId)}>
      {(objectUrl) => <ObjectFitImage src={objectUrl} cover={true}/>}
    </RemoteImage>;
  };

  const displayExtension = (file: UploadedFile) => {
    if (file.thumbnailSize && file.thumbnailSize > 0) {
      return null;
    }

    return <div className={styles.attachmentExt}>{props.extension}</div>;
  };
  
  const renderListItems = (files: UploadedFile[]) => {
    return files.map((file, index) =>
      <div className={styles.itemWrapper} key={index}>
        <div className={`${styles.notEditing} ${file.mainImage ? styles.main : ''} ${styles.attachment}`}>    
          <div className={styles.attachmentImg}>     
            {thumbnail(file)}      
            {displayExtension(file)}
            {file.mainImage && <div className={styles.marked}><MdStar /></div> }
          </div>
          <div className={styles.attachmentBody}>
            {renderTitle(file)}
            {renderMetadata(file)}
          </div>
        </div>    
      </div>);
  };
  
  const displayUploadedFiles = !!props.uploadedFiles?.length && !!props.print;
  
  return (<>
    {!!displayUploadedFiles? <div id={`${props.componentId}`} className={`${props.className} ${styles.listWrapper}`}>      
      {renderListItems(props.uploadedFiles)}
    </div> : null}
  </>);
};
